import React from "react";

export default function DeleteConfirm({
  message,
  onConfirm,
  onCancel,
}: {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div>
      <p>{message}</p>
      <div className="flex justify-end gap-2 mt-4">
        <button onClick={onCancel} className="border rounded px-2 py-1">
          Cancel
        </button>
        <button onClick={onConfirm} className="border rounded px-2 py-1 bg-red-500 text-white">
          Delete
        </button>
      </div>
      <p className="text-sm text-gray-500 mt-2">
        This action cannot be undone.
      </p>
    </div>
  );
}
